/* tslint:disable */
/* eslint-disable */
/**
 * Swagger wiegaaterkoffiehalen
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.3.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type Invite,
    InviteFromJSON,
    InviteToJSON,
} from '../models/Invite';

export interface GetInviteRequest {
    /**
     * The ID of the invite
     */
    inviteId: string;
}

/**
 * 
 */
export class InviteApi extends runtime.BaseAPI {

    /**
     * Creates request options for getInvite without sending the request
     */
    async getInviteRequestOpts(requestParameters: GetInviteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['inviteId'] == null) {
            throw new runtime.RequiredError(
                'inviteId',
                'Required parameter "inviteId" was null or undefined when calling getInvite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/invite/{inviteId}`;
        urlPath = urlPath.replace('{inviteId}', encodeURIComponent(String(requestParameters['inviteId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a invite
     */
    async getInviteRaw(requestParameters: GetInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invite>> {
        const requestOptions = await this.getInviteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InviteFromJSON(jsonValue));
    }

    /**
     * Get a invite
     */
    async getInvite(requestParameters: GetInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invite> {
        const response = await this.getInviteRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
